import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { exerciseType } from "../../components/constants/constants";
import { TemplateSetting } from "../../components/exercise_types_helper/template_settings";
import { WritingSetting } from "../../components/exercise_types_helper/writing_settings";
import { toast } from "react-toastify";
import { Col, Row } from "reactstrap";
import { GenaiUrl } from "../../libs/env";
import { disableFields } from "../../components/constants/constants";
import { useLocation } from "react-router-dom";

const CustomTemplateForm = ({
  Dropdownitems,
  GenerateQuiz,
  data,
  setExerciseData,
  IsGenerating,
  UserActiveToggle,
  setShowSocketData,
  formData,
  setFormData,
  clearformData,
  setIsStopGenerating,
  IsStopGenerating,
  setIsRegenerating,
  setIsGenerating,
  generate_button,
}) => {
  const { pathname } = useLocation();
  let user_activation = window.sessionStorage.getItem("user_is_active");
  const [isvalidTheme, setisvalidTheme] = useState(null);
  useEffect(() => {
    // Generate a random number to use as a suffix for the tab ID
    const randomSuffix = Math.floor(Math.random() * 1000000);

    // Create a unique tab ID by combining window.name and the random suffix
    const id = `${window.name}-${randomSuffix}`;

    // Set the tab ID state variable with the generated ID
    sessionStorage.setItem(`senderIDkey`, id);
  }, []);

  useEffect(() => {
    const channel = new BroadcastChannel(
      `tab-channel-${Dropdownitems?.user_id}`
    );
    if (IsGenerating) {
      channel.postMessage({
        type: "form-submitted",
        tabsenderKey: sessionStorage.getItem("senderIDkey"),
      });
    }
    channel.addEventListener("message", handleMessage);
  }, [IsGenerating, Dropdownitems]);

  function handleMessage(event) {
    const message = event.data;
    if (message.type === "form-submitted") {
      if (message.tabsenderKey !== sessionStorage.getItem("senderIDkey")) {
        // The message was sent from another tab
        setShowSocketData(false);
      } else {
        setShowSocketData(true);
      }
    }
  }

  const formSubmit = (event) => {
    event.preventDefault();
    if (user_activation === "true") {
      var isCredits;
      if (formData?.credits.includes("-")) {
        const minEstimation = formData?.credits.split("-")[0];
        isCredits = Dropdownitems?.remaining_credits >= minEstimation;
      } else {
        isCredits = Dropdownitems?.remaining_credits >= formData?.credits;
      }
      if (isCredits) {
        if (pathname.includes(GenaiUrl)) {
          clearformData("generate_use_template");
        }
        GenerateQuiz(formData);
      } else {
        toast.error(
          `*Insufficient credits: Add more credits for generate this exercise`,
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            toastId: 1,
          }
        );
      }
    } else {
      UserActiveToggle();
    }
    // if (formData.topic || data?.disable_fields_for_template?.includes(disableFields.THEME)) {
    // } else {
    //   setisvalidTheme("Theme is required*");
    // }
  };
  const handleSelectedValue = (event) => {
    let { name, value } = event;
    setisvalidTheme(null);
    if (user_activation === "true") {
      let selected_voices = {}
      if (name === undefined) {
        name = "topic";
      }
      else if (name === "speaker_1" || name === "speaker_2") {
        selected_voices = formData?.voice_id ? formData?.voice_id : {}
        selected_voices[name] = value
        name = "voice_id";
        value = selected_voices
      }
      setFormData((prevState) => ({ ...prevState, [name]: value }));
    } else {
      UserActiveToggle();
    }
    if (pathname.includes(GenaiUrl)) {
      clearformData();
    }
  };
  useEffect(() => {
    setExerciseData((ExerciseData) => ({
      ...ExerciseData,
      task_level: formData?.cefr_level ? formData?.cefr_level : "A1",
      task_type: formData?.exercise_type
        ? formData?.exercise_type
        : "Reading Task",
      task_theme: formData?.topic ? formData?.topic : "",
      recom_time: formData?.time_allowed ? formData?.time_allowed : "10",
      disable_form_fields: data?.disable_fields_for_template
        ? data?.disable_fields_for_template
        : [],
      gpt_quick_actions: data?.gpt_quick_actions
        ? data?.gpt_quick_actions
        : [],
      task_exercise_types: data?.task_exercise_types
        ? data?.task_exercise_types
        : [],
      hide_task_level: data?.hide_task_level ? data?.hide_task_level : false,
      voice_id: formData?.voice_id
        ? formData?.voice_id
        : data?.default_voice
        ? data?.default_voice
        : null,
      socket_id: formData?.socket_id,
      age_group: data?.age_group ? data?.age_group: "",
      dalle_prompt: data?.dalle_prompt ? data?.dalle_prompt: "",
      ai_grading_task: data?.ai_grading_task ? data?.ai_grading_task: false,
      template_id: formData?.exercise_id ? formData?.exercise_id : "",
    }));
  }, [data, formData, Dropdownitems]);
  useEffect(() => {
    if (data?.approved_for_templates) {
      var est_credits = "0";
      if (Dropdownitems?.exercise_credits) {
        Dropdownitems.exercise_credits.forEach((credit) => {
          if (credit.exercise_type === data?.task_type) {
            est_credits = String(credit.estimated_credits);
          }
        });
      }
      setFormData((formData) => ({
        ...formData,
        cefr_level:
          data?.task_levels && !data?.hide_task_level
            ? data?.task_levels[0]?.value
            : "",
        exercise_type: data?.task_type ? data?.task_type : "",
        time_allowed: data?.recom_time ? data?.recom_time : "",
        question_type: data?.questions ? data?.questions[0]?.type : "",
        exercise_id: data?.id ,
        use_template: true,
        options:
          data?.questions &&
          (data?.questions[0]?.type === "FillInBlank" ||
            data?.questions[0]?.type === "DragAndDropCrossMatch")
            ? "1" : "",
        credits: data?.estimated_credits
          ? data?.estimated_credits
          : data?.exercise_form_prompt?.credits
          ? String(data?.exercise_form_prompt.credits)
          : est_credits,
        voice_id: formData?.voice_id
          ? formData?.voice_id
          : data?.default_voice
          ? data?.default_voice
          : null,
        socket_id: Dropdownitems?.user_id,
      }));
    } else {
      setFormData((formData) => ({
        ...formData,
        cefr_level: formData?.cefr_level ? formData?.cefr_level : data?.exercise_form_prompt?.cefr_level
          ? data?.exercise_form_prompt.cefr_level
          : "",
        exercise_type: formData?.exercise_type ? formData?.exercise_type : data?.exercise_form_prompt?.exercise_type
          ? data?.exercise_form_prompt.exercise_type
          : "",
        time_allowed: formData?.time_allowed ? formData?.time_allowed : data?.exercise_form_prompt?.time_allowed
          ? data?.exercise_form_prompt.time_allowed
          : "",
        topic: formData?.topic ? formData?.topic : data?.exercise_form_prompt?.topic
          ? data?.exercise_form_prompt.topic
          : "",
        question_type: formData?.question_type ? formData?.question_type : data?.exercise_form_prompt?.question_type
          ? data?.exercise_form_prompt.question_type
          : "",
        options: formData?.options && formData?.options !== "1" ? formData?.options : data?.exercise_form_prompt?.options
          ? parseInt(data?.exercise_form_prompt.options)
          : "",
        questions: formData?.questions ? formData?.questions : data?.exercise_form_prompt?.questions
          ? parseInt(data?.exercise_form_prompt.questions)
          : "",
        detail: formData?.detail ? formData?.detail : data?.exercise_form_prompt?.detail
          ? data?.exercise_form_prompt.detail
          : "",
        vocab: formData?.vocab ? formData?.vocab : data?.exercise_form_prompt?.vocab
          ? data?.exercise_form_prompt.vocab
          : "",
        grammar_type: formData?.grammar_type ? formData?.grammar_type : data?.exercise_form_prompt?.grammar_type
          ? data?.exercise_form_prompt.grammar_type
          : "",
        task_style: formData?.task_style ? formData?.task_style : data?.exercise_form_prompt?.task_style
          ? data?.exercise_form_prompt.task_style
          : "",
        formality: formData?.formality ? formData?.formality : data?.exercise_form_prompt?.formality
          ? data?.exercise_form_prompt.formality
          : "",
        recom_words: formData?.recom_words ? formData?.recom_words : data?.exercise_form_prompt?.recom_words
          ? data?.exercise_form_prompt.recom_words
          : "",
        credits: formData?.credits && formData?.credits !== "0" ? formData?.credits : data?.exercise_form_prompt?.credits
          ? String(data?.exercise_form_prompt.credits)
          : "0",
        exercise_id: formData?.exercise_id ? formData?.exercise_id : data?.exercise_form_prompt?.exercise_id
          ? data?.exercise_form_prompt.exercise_id
          : "",
        use_template: true,
        action_value: formData?.action_value ? formData?.action_value : data?.exercise_form_prompt?.action_value
        ? data?.exercise_form_prompt.action_value
        : "",
        voice_id: formData?.voice_id ? formData?.voice_id : data?.exercise_form_prompt?.voice_id
          ? data?.exercise_form_prompt.voice_id
          : null,
        socket_id: Dropdownitems?.user_id
      }));
    }
  }, [data, Dropdownitems]);
  const handleInputChange = (event) => {
    let { name, value } = event.target;
    if (user_activation === "true") {
      if (name === "cefr_level") {
        value = value.split(" ")[0];
      }
      if (name === "question_type") {
        if (value === "FillInBlank" || value === "DragAndDropCrossMatch") {
          setFormData((prevState) => ({ ...prevState, options: 1 }));
        }
      }
      setFormData((prevState) => ({ ...prevState, [name]: value }));
    } else {
      UserActiveToggle();
    }
    if (pathname.includes(GenaiUrl)) {
      clearformData();
    }
  };
  const handleQuickAction = (value) => {
    if(!IsGenerating && IsStopGenerating)
    {
      setFormData((prevState) => ({ ...prevState, "action_value": value }));
      setTimeout(() => {
        setIsStopGenerating(false);
        setIsRegenerating(true);
        generate_button();
      }, 100);
    }
    else{
      setFormData((prevState) => ({ ...prevState, "action_value": value }));
      setTimeout(() => {
        generate_button();
      }, 100);
    }
  };
  const handleScroll = (e) => {
    var timer;
    const container = e.target ;
    if (container)
    {
      container.classList.add('scrollable_scroll');
    }
    clearTimeout(timer);
    timer = setTimeout(() => {
      container.classList.remove('scrollable_scroll');
    }, 1000);
  };

  // let used_credits_pct = 0;

  // if (allocated_credits &&  total_credits) {
  //   used_credits_pct = Math.floor((allocated_credits / total_credits) * 100);
  // }
  return (
    <form onSubmit={formSubmit}>
      <Row className="g-0 px-2">
        <div>
        <div className="p-4">
          <div className="template_scroll" onScroll={handleScroll}>
            <div className="pb-2 ps-2">
              <h2 class="fs-5">
                <svg width="25" height="25" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_5068_7784)">
                  <path d="M10.0625 4.375H10.4426C13.1089 4.375 14.4421 4.375 14.9482 4.85388C15.3856 5.26782 15.5795 5.87762 15.4614 6.46818C15.3248 7.15139 14.2363 7.92125 12.0595 9.46096L8.503 11.9765C6.32617 13.5162 5.23774 14.2861 5.10111 14.9693C4.983 15.5599 5.17686 16.1697 5.61432 16.5836C6.12039 17.0625 7.45356 17.0625 10.1199 17.0625H10.9375M7 4.375C7 5.82475 5.82475 7 4.375 7C2.92525 7 1.75 5.82475 1.75 4.375C1.75 2.92525 2.92525 1.75 4.375 1.75C5.82475 1.75 7 2.92525 7 4.375ZM19.25 16.625C19.25 18.0747 18.0747 19.25 16.625 19.25C15.1753 19.25 14 18.0747 14 16.625C14 15.1753 15.1753 14 16.625 14C18.0747 14 19.25 15.1753 19.25 16.625Z" stroke="#2E58D4" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_5068_7784">
                  <rect width="21" height="21" fill="white"/>
                  </clipPath>
                  </defs>
                </svg>
                <b className="ps-2">Make your own version of this task </b>
              </h2>
              {/* <p className="text-dark pt-2">Generate a unique version of this task whilst retaining the same question type.</p> */}
            </div>
            <div>
              {data && data?.gpt_quick_actions?.length > 0 && (
                <div className="m-2">
                  <h3 class="fs-6 pb-2 fw-600">
                    {" "}
                    <span>Quick actions:</span>
                  </h3>
                  <div>
                  {data?.gpt_quick_actions.map((quick_action) => {
                      return (
                        <button key={quick_action.value} disabled={IsGenerating} onClick={() => handleQuickAction(quick_action.value)} type="button"  className={`text-start btn py-1 px-3 rounded-5 me-2 mt-2 ${formData?.action_value === quick_action.value ? 'temp-btn-active' : 'btn-light border'}`}>                            
                          {quick_action.value}
                        </button>
                      );
                  })}
                  </div>
                  <div> <hr class="or-text" /></div>
                </div>)}
            </div>
            {data &&
              !data?.disable_fields_for_template?.includes(
                disableFields.ADVANCE_SETTINGS
              ) && (
                <div>
                  <h3 class="fs-6 fw-600 p-2">
                    {" "}
                    <span>Describe topic (optional)</span>
                    {/* <span class="custom_tooltip">
                      <span class="ps-1">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="8" cy="8" r="6" stroke="black" stroke-width="2"/>
                        <path d="M8.33366 5.00008C8.33366 5.18418 8.18442 5.33342 8.00033 5.33342C7.81623 5.33342 7.66699 5.18418 7.66699 5.00008C7.66699 4.81599 7.81623 4.66675 8.00033 4.66675C8.18442 4.66675 8.33366 4.81599 8.33366 5.00008Z" fill="black" stroke="black"/>
                        <path d="M8 11.3334V6.66675" stroke="black" stroke-width="2"/>
                      </svg>
                      </span>
                      <span class="tooltip_content theme_tooltip">
                        Add more details about what you would like to include in
                        the task. This will be in addition to the selected theme.
                        For example: “Make it about Tom and Mary discussing the
                        Lord of the Rings”.
                      </span>
                    </span> */}
                  </h3>
                  <Col className="col-12">
                    <div class="col-12 sm-flex">
                      <div class="col-12 p-2">
                        <div>
                          <textarea
                            class="form-control rounded-5 py-2"
                            name="detail"
                            rows="5"
                            cols="97"
                            placeholder="Make the task about popular foods around the world. Include all types of cuisines."
                            value={formData.detail}
                            onChange={handleInputChange}
                            disabled={IsGenerating}
                            // required={formData?.action_value ? false : true}
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </Col>
                </div>
              )}
            <div>
              {data?.task_type === exerciseType.WRITING_TASK ? (
                <WritingSetting
                  handleSelectedValue={handleSelectedValue}
                  formData={formData}
                  data={data}
                  Dropdownitems={Dropdownitems}
                  handleInputChange={handleInputChange}
                  IsGenerating={IsGenerating}
                  isvalidTheme={isvalidTheme}
                  templateView={true}
                />
              ) : (
                data && (
                  <TemplateSetting
                    handleSelectedValue={handleSelectedValue}
                    formData={formData}
                    data={data}
                    Dropdownitems={Dropdownitems}
                    handleInputChange={handleInputChange}
                    IsGenerating={IsGenerating}
                    isvalidTheme={isvalidTheme}
                  />
                )
              )}
            </div>
          </div>
          <div className="col-12 d-flex align-items-center pt-3">
            <Col className="col-12 text-center px-2">
              {IsGenerating ? (
                <button
                  class="btn btn-lg btn-darkblue px-4 rounded-5 fs-8"
                  type="button"
                  onClick={() => {
                    setIsStopGenerating(true);
                    setIsGenerating(false);
                    setIsRegenerating(false);
                  }}
                >
                  <span
                    class="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Stop generating
                </button>
              ) : !IsGenerating && IsStopGenerating ? (
                <>
                  <button
                    class="btn btn-lg btn-darkblue px-4 py-1 rounded-5 fs-8"
                    type="button"
                    onClick={() => {
                      setIsStopGenerating(false);
                      setIsGenerating(true);
                      setIsRegenerating(true);
                      generate_button();
                    }}
                  >
                    <svg width="20" height="22" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.94185 1L1.38706 8.4815C1.13036 8.7745 1.002 8.921 1.00004 9.04472C0.998337 9.15228 1.04873 9.25461 1.13669 9.32222C1.23788 9.4 1.43837 9.4 1.83936 9.4H7.2059L6.46994 15L13.0247 7.5185C13.2814 7.2255 13.4098 7.079 13.4118 6.95528C13.4135 6.84772 13.3631 6.74539 13.2751 6.67777C13.1739 6.6 12.9734 6.6 12.5724 6.6H7.2059L7.94185 1Z" stroke="white" stroke-width="1.4719" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <b className="ps-1">Regenerate Task</b>
                  </button>
                  <button
                    type="submit"
                    rel="nofollow"
                    id="SubmitForm"
                    class="d-none"
                  >
                    <b>Regenerate</b>
                  </button>
                </>
              ) : (
                <button
                  type="submit"
                  href="#"
                  rel="nofollow"
                  id="SubmitForm"
                  class="btn btn-lg fs-8 btn-darkblue px-4 w-100 rounded-5 fs-8"
                >
                  <svg width="20" height="22" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.94185 1L1.38706 8.4815C1.13036 8.7745 1.002 8.921 1.00004 9.04472C0.998337 9.15228 1.04873 9.25461 1.13669 9.32222C1.23788 9.4 1.43837 9.4 1.83936 9.4H7.2059L6.46994 15L13.0247 7.5185C13.2814 7.2255 13.4098 7.079 13.4118 6.95528C13.4135 6.84772 13.3631 6.74539 13.2751 6.67777C13.1739 6.6 12.9734 6.6 12.5724 6.6H7.2059L7.94185 1Z" stroke="white" stroke-width="1.4719" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>

                  <b className="ps-1">Generate your own version</b>
                </button>
              )}
            </Col>
          </div>
        </div>
        </div>
      </Row>
    </form>
  );
};

export default CustomTemplateForm;
